export default __webpack_public_path__ + "static/media/diverse01-1.5x.802a8a7b.png";